export const nieuwWerkContent = {
  nl: {
    seoTitle: 'Huidig werk · Rot8ion · Perpetual Plexus',
    seoDescription:
      'Huidig werk van Rob van Rooij (Rot8ion): lichtsculpturen en mixed media werken. Ontdek composities waarin licht, video, audio en netwerkcommunicatie samenkomen.',
    introductionTitle: 'Rot8ion',
    introduction:
      'Sinds 2007 onderzoekt Rot8ion het spanningsveld tussen kunst en technologie. Zijn werk is de afgelopen decennia getransformeerd van DJ sets, live geluids improvisaties, soundscapes en vj sets in het nachtleven van Eindhoven en omgeving, naar permanente mixed media installaties. Werkend met zelfgemaakte software, electronica en hardware, muziek, video, lichtbronnen, hout, acrylglas en acrylverf, vertaalt Rot8ion zintuigen naar composities waarin licht, video, audio en netwerkcommunicatie elkaar voortdurend beïnvloeden.',
    quote: [
      'Licht als verbinding in het donker',
      'Ik visualiseer verbindingen',
      'Verbindingen van hoop en saamhorigheid tussen locaties en mensen',
      'Aan het uiteinde van elke verbinding bevindt zich een lichtsculptuur',
      'Deze lichtsculpturen maken de verbinding zichtbaar en sterker',
      'Zo vormt zich een netwerk van communicerende lichtsculpturen',
      'Dat netwerk is Perpetual Plexus',
    ],
    title: 'Huidig werk',
    intro: 'Een selectie van recente lichtsculpturen en mixed media werken.',
  },
  en: {
    seoTitle: 'Current work · Rot8ion · Perpetual Plexus',
    seoDescription:
      'Current work by Rob van Rooij (Rot8ion): light sculptures and mixed media pieces. Discover compositions in which light, video, audio and network communication come together.',
    introductionTitle: 'Rot8ion',
    introduction:
      'Since 2007, Rot8ion has been exploring the tension between art and technology. His work has transformed over the past decades from DJ sets, live sound improvisations, soundscapes and VJ sets in the nightlife of Eindhoven and surroundings, to permanent mixed media installations. Working with self-made software, electronics and hardware, music, video, light sources, wood, acrylic glass and acrylic paint, Rot8ion translates senses into compositions in which light, video, audio and network communication continuously influence each other.',
    quote: [
      'Light as connection in the dark',
      'I visualize connections',
      'Connections of hope and togetherness between places and people',
      'At the end of every connection is a light sculpture',
      'These light sculptures make the connection visible and stronger',
      'Thus a network of communicating light sculptures is formed',
      'That network is Perpetual Plexus',
    ],
    title: 'Current work',
    intro: 'A selection of recent light sculptures and mixed media works.',
  },
} as const;
